import React from 'react';
import {
  Box,
  Button,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import { ArrowBack, Edit as EditIcon } from '@mui/icons-material';
import { labelTipoArticulo } from '../../../../config/tipoArticuloOptions';
import { ProductoFoto } from '../../../../utils/productImage';
import { resolveClasificacionCompleta } from '../productoClasificacion';
import ProductoInfo360Thumbnail from './ProductoInfo360Thumbnail';

export interface ProductoInfo360Maestro {
  codigoArticulo: string;
  descripcion: string;
  codBarra?: string | null;
  plu?: string | null;
  tipoArticulo?: string | null;
  idUnidadMedida?: string | null;
  codigoRamo?: string | null;
  codigoLinea?: string | null;
  codigoClase?: string | null;
  nombreRamo?: string | null;
  nombreLinea?: string | null;
  nombreClase?: string | null;
  codProveedor?: number | null;
  codigoProveedor?: string | null;
  atributo1?: string | null;
  atributo2?: string | null;
  atributo3?: string | null;
  tipoMoneda?: number | null;
  lista?: string | null;
  costo?: number | null;
  precioVenta?: number | null;
  precio?: number | null;
  fechaUltCosto?: string | null;
  fechaUltPrecio?: string | null;
  porcentajeMkpminimo?: number | null;
  precioMinimo?: number | null;
  porcentajeGanan?: number | null;
  calculaIva?: string | null;
  ivaCF?: number | null;
  stockOptimo?: number | null;
  stockMin?: number | null;
  stockMax?: number | null;
  stockProduccion?: number | null;
  stockVenta?: number | null;
  stockPedido?: number | null;
  cantOrdenCompra?: number | null;
  cantidad?: number | null;
  imagen?: string | null;
  fotos?: ProductoFoto[] | null;
  um?: string | null;
  unidadMedida?: string | { idUnidadMedida?: string; descripcion?: string } | null;
}

interface Props {
  producto: ProductoInfo360Maestro;
  onVolver: () => void;
  onEditarMaestro: () => void;
}

const ArticuloInfo360Header: React.FC<Props> = ({ producto, onVolver, onEditarMaestro }) => {
  const nombre = producto.descripcion?.trim() || producto.codigoArticulo;
  const clasificacion = resolveClasificacionCompleta(producto);
  const esInactivo = ['INA', 'DIS'].includes((producto.tipoArticulo ?? '').toUpperCase());

  return (
    <Stack spacing={1.5}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
      >
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <ProductoInfo360Thumbnail producto={producto} dimension={72} />
          <Box>
            <Button
              startIcon={<ArrowBack />}
              onClick={onVolver}
              sx={{ textTransform: 'none', mb: 0.5, px: 0, minWidth: 0 }}
              aria-label="Volver"
            >
              Volver
            </Button>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#1976d2' }}>
              Info 360
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 600, mt: 0.5 }}>
              {nombre}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              #{producto.codigoArticulo}
              {producto.codBarra ? ` · Cód. barras ${producto.codBarra}` : ''}
              {producto.tipoArticulo ? ` · ${labelTipoArticulo(producto.tipoArticulo)}` : ''}
            </Typography>
          </Box>
        </Stack>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<EditIcon />}
          onClick={onEditarMaestro}
          sx={{ textTransform: 'none', alignSelf: { xs: 'stretch', sm: 'flex-start' } }}
        >
          Editar maestro
        </Button>
      </Stack>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <Chip
          size="small"
          label={esInactivo ? 'Inactivo' : 'Activo'}
          color={esInactivo ? 'default' : 'success'}
          variant="outlined"
        />
        {clasificacion ? (
          <Chip size="small" label={clasificacion} variant="outlined" />
        ) : null}
        {producto.codProveedor || producto.codigoProveedor ? (
          <Chip
            size="small"
            label={`Proveedor: ${producto.codigoProveedor || `#${producto.codProveedor}`}`}
            variant="outlined"
          />
        ) : null}
        {producto.idUnidadMedida ? (
          <Chip size="small" label={`UM: ${producto.idUnidadMedida}`} variant="outlined" />
        ) : null}
      </Stack>
    </Stack>
  );
};

export default ArticuloInfo360Header;
